export enum ResponseError {
  UNAUTHORIZED,
  FORBIDDEN,
  NOT_FOUND,
  SERVICE_UNAVAILABLE,
  UNKNOWN,
}
